import React, { Component } from 'react'
import Dialog from 'react-bootstrap-dialog'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loader from 'react-loader-advanced'
import * as Constants from '../../../../common/constants'
import { employeesMovementTableReady } from '../../redux/employeesmovement'
import { buildNumberUpdate, } from '../../../../redux/user'
import apiService from '../../services/apiservices'



//import * as Helpers from '../../../../common/helpers'

import { EntityStatus,Reasons } from '../../../../common/DropDowns'

class EmployeeMovementResponderModalLayout extends Component {
    constructor() {
        super()
        this.state = {
            reasons: {},
            isUpdating: false,
            status: '',
            reasonId: '',
            remarks: '',

            remarksErrorText: false,
            remarksErrorData: '',

            statusErrorText: false,
            statusErrorData: '',

            reasonIdErrorText: false,
            reasonIdErrorData: '',
        }
        this.dialog = null

        this.isComponentStillMount = true

        this.statusComponent = null
        this.statusSection = null

        this.remarksComponent = null
        this.remarksSection = null

        this.reasonIdComponent = null
        this.reasonIdSection = null
    }

    componentWillMount() {
        this.isComponentStillMount = true
    }

    componentDidMount() {

        this.setState({
            status:this.props.data.status 
        });
    }


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMount = false
    }


    handleChanges = () => {
    }

    submitData = () => {
        let data = {}
        data.create_again=0
        
        
    }


    handleOnChange = (e) => {
   
        this.setState({
           file : e.target.files[0] 
        });
    };

     entityStatusChange= (data) => {
    
        this.statusComponent.value=data.value
    
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
            
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }

     reasonChange= (data) => {
    
        this.reasonIdComponent.value=data.value
    
        this.setState({
            reasonId :data.value,
            reasonIdErrorText: false,
            reasonIdErrorData: ''
        })
            
        this.reasonIdSection.className= this.reasonIdSection.className.replace(" has-error", "")
    }




    

    handleOnSubmit = (e) => {

        e.preventDefault();

        this.props.dispatch(employeesMovementTableReady(false))
        let data = {}


        let statusObject = this.mandateValidation("status", Constants.FORM_SELECT)
        if (statusObject.status) {
            data.status=this.statusComponent.value         

        } else {
            this.props.dispatch(employeesMovementTableReady(true))
            return
        }

  
    if(this.statusComponent.value==="REJECTED"){
    
        let reasonIdObject = this.mandateValidation("reasonId", Constants.FORM_SELECT)
        if (reasonIdObject.status) {
            data.status_reason_id = this.reasonIdComponent.value
        } else {

             this.props.dispatch(employeesMovementTableReady(true))
            return
        }
    }

    
    data.status_remarks = this.remarksComponent.value



    let apiPayloadData=data;


    apiService.editEmployeeMovement(apiPayloadData,this.props.data.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(employeesMovementTableReady(true))
                        this.props.closeModal(false)
                        window.location.reload()
                    } else {

                        this.props.dispatch(employeesMovementTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(employeesMovementTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })




}



  
    render() {

        return (
            <div className="qr-code-reader-modal">
                <Dialog ref={el => this.dialog = el} />
                <Loader
                    show={this.state.isUpdating}
                    message={'Updating...Please wait'}
                    foregroundStyle={{ color: "#ffffff", fontSize: "17px", fontWeight: "600" }}>
                    <div className="modal-header">
                        <button type="button" className="close"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>
                            <span>&times;</span></button>
                        <h4 className="modal-title">Movement request for {this.props.data.employee_name} - {this.props.data.employee_code}</h4>
                    </div>

                    <div className="modal-body">
                            <div className="form-horizontal">

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-11 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.statusSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "5px"}}>Status *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.statusComponent = el}>
                                                              <EntityStatus type="EMPLOYEE_MOVEMENTS" removeInTransist="YES" entityStatusChange={this.entityStatusChange} selectedValue={this.state.status} />
                                                              <span className="help-block" style={{ display: this.state.statusErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.statusErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                            </div>

                                           
                                             {(() => {

                                                if(this.state.status==="REJECTED"){
                                                    return(
                                                          
                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <div className="col-md-11 col-sm-12 col-xs-12">
                                                                <div className="form-group" ref={el =>
                                                                       this.reasonIdSection = el}>
                                                                       <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason *</label>
                                                                       
                                                             <div className="col-sm-9" ref={el =>
                                                                      this.reasonIdComponent = el}>
                                                                      <Reasons type="MOVEMENT_STATUS" reasonChange={this.reasonChange} selectedValue={this.state.reasonId} />
                                                                      <span className="help-block" style={{ display: this.state.reasonIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                      {this.state.reasonIdErrorData}
                                                                      </span>
                                                                    </div>
                                                                    </div>
                                                            </div>                                          
                                                    </div>

                                              )
                                                }

                                            })()}

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-11 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                            </div>
                    </div>
                    <div className="modal-footer" style={{marginTop: "13%"}}>
                        <button type="button" className="btn btn-primary pull-left"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>Close</button>
                            <button
                                    className="btn btn-info pull-right"
                                    style={{ width: "auto" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.handleOnSubmit(e);
                                    }} >
                                    Submit
                                </button>
                    </div>

            </Loader>
            </div>
        )
    }


    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        employeesmovement: state.employeesmovement,
    }
}

export default connect(mapStateToProps)(withRouter(EmployeeMovementResponderModalLayout))


// WEBPACK FOOTER //
// ./src/modules/Employees Movement/Components/EmployeeMovementResponderModalLayout/EmployeeMovementResponderModalLayout.js